module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "sp-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-12 foot-links",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("How to use")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("©  2015 Sellpoint. All rights reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d65b7be"}!./src/pages/MainFooter/template.html
// module id = 272
// module chunks = 0